import { createContext, useContext } from "react";
import en from "./content/en";
import sq from "./content/sq";
import it from "./content/it";
import de from "./content/de";
import es from "./content/es";
import fr from "./content/fr";
import pt from "./content/pt";

export const DICTS = { en, sq, it, de, es, fr, pt };
export const LangContext = createContext({ lang: "en", t: en });
export const useT = () => useContext(LangContext);
